module.exports = __webpack_public_path__ + "img/account.1fa47818.svg";